import { BaseCustomElement } from "brut-js"

class PlanUpdate extends BaseCustomElement {
  static tagName = "cc-plan-update"
  static observedAttributes = [
    "show-warnings",
    "editing",
    "default-state",
  ]

  #defaultToViewing = true

  editingChangedCallback({newValueAsBoolean}) { }

  defaultStateChangedCallback({newValue}) {
    this.#defaultToViewing = newValue !== "editing"
  }

  onConnected() {
    if (this.#defaultToViewing) {
      this.removeAttribute("editing")
    } else {
      this.setAttribute("editing", "")
    }
  }

  #showEditor = (event) => {
    event.preventDefault()
    this.setAttribute("editing", "")
    setTimeout( this.#focusTextarea, 100 )
  }
  #hideEditor = (event) => {
    event.preventDefault()
    this.removeAttribute("editing")
  }

  #resetForm = (event) => {
    event.preventDefault()
    event.currentTarget.form.reset()
  }

  #focusTextarea = () => {
    const textarea = this.querySelector("textarea[name=description]")
    if (textarea) {
      textarea.focus()
    }
  }

  update() {
    const editButtonSelector = "cc-plan-update-edit-button button"
    const showEditButton     = this.querySelector(editButtonSelector)
    const cancelEditButton   = this.querySelector("button[type=reset]")

    if (!showEditButton) {
      this.logger.info("Could not find edit button from selector %s", editButtonSelector)
      return
    }

    if (!cancelEditButton) {
      this.logger.info("Could not find a button with type=reset to use for cancling editing")
      return
    }

    showEditButton.addEventListener("click", this.#showEditor)
    cancelEditButton.addEventListener("click", this.#hideEditor)
    cancelEditButton.addEventListener("click", this.#resetForm)
  }
}
export default PlanUpdate
